import cn from './cn.js';

/**
 * Lightweight CSS tooltip. Wrap any element; `content` shows on hover/focus.
 * For long or interactive content use a Popover instead.
 */
export default function Tooltip({ content, side = 'top', className, children, delay = false }) {
  if (!content) return children;
  const pos = {
    top: 'bottom-full left-1/2 mb-2 -translate-x-1/2',
    bottom: 'top-full left-1/2 mt-2 -translate-x-1/2',
    left: 'right-full top-1/2 mr-2 -translate-y-1/2',
    right: 'left-full top-1/2 ml-2 -translate-y-1/2',
  }[side];
  return (
    <span className={cn('group/tt relative inline-flex', className)}>
      {children}
      <span
        role="tooltip"
        className={cn(
          'pointer-events-none absolute z-[80] whitespace-nowrap rounded-md bg-gray-900 px-2 py-1 text-xs font-medium text-white opacity-0 shadow-pop transition-opacity duration-100 group-hover/tt:opacity-100 group-focus-within/tt:opacity-100',
          delay && 'group-hover/tt:delay-300',
          pos,
        )}
      >
        {content}
      </span>
    </span>
  );
}
